export const DEFAULT_ROUTES = {
  INDEX: "/",
  SIGNIN: "/signin",
  BOOKINGS: "/bookings",
  BOOKING_CREATE: "/bookings/create",
};
